import { Layout } from "dashboard-assistant";
import { makeWidgetContainer } from "./widget";

export class Dashboard {
    constructor() {
    }

    update(layout: Layout | null) {
        let elem = document.getElementById("dashboard")!;
        elem.innerHTML = "";
        if (layout) {
            elem.appendChild(makeWidgetContainer(layout));
        }
    }
}
